import { Component, OnInit } from '@angular/core';
import { FaqItem } from '@app/models/help/help.models';
import { LocalisationService } from '@app/services/localisation.service';

@Component({
  selector: 'help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  static route: string = 'help';

  locale: any = {};
  items: FaqItem[];

  constructor(private localisation: LocalisationService) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('HelpComponent');

    this.items = <FaqItem[]>this.locale.items;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/help/help/help.component.ts